import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {deleteBillingContact, editBillingContact, validEmail} from '../../../services';
import FormGroupRowText from "../../../Elements/FormGroupRowText";
import FormGroupRowSelect from "../../../Elements/FormGroupRowSelect";
import {withRefresh} from "../../../Elements/Fetch";
import FormWithActions from "../../../Elements/FormWithActions/FormWithActions";
import {Button, ButtonGroup, Col, Row} from "reactstrap";
import FormGroupRowCheckbox from "../../../Elements/FormGroupRowCheckbox";
import {sectorTypes} from "../dropDownData";


class BillingContactEditForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            firstName: props.billingContact.firstName,
            lastName: props.billingContact.lastName,
            email: props.billingContact.email,
            language: props.billingContact.language,
            getBillingReport: props.billingContact.getBillingReport,
            contactPointType: props.billingContact.contactPointType,
            sectorType: props.billingContact.sectorType
        };

        this.handleAction = this.handleAction.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleAction(action) {
        switch (action) {
            case 'submit':
                return editBillingContact(this.props.billingContact.id, this.state)
                    .then(data => {
                        this.props.triggerRefresh(`billingSender:${this.props.billingSenderId}`, true);
                        this.props.onSubmit();
                        return data;
                    });
            case 'delete':
                return deleteBillingContact(this.props.billingContact.id)
                    .then(data => {
                        this.props.triggerRefresh(`billingSender:${this.props.billingSenderId}`, true);
                        this.props.onSubmit();
                        return data;
                    });
            default:
            //do nothing
        }
    }
    handleChange(value, attribute) {
        this.setState({
            [attribute]: value,
        });

    }
    render() {
        let disableSubmitReason = '';
        if (!this.state.email) {
            disableSubmitReason = "The e-mail address is required.";
        } else if (!validEmail(this.state.email)) {
            disableSubmitReason = "The e-mail address must be valid.";
        }

        const actions = [
            {
                action: 'delete',
                displayName: 'Delete',
                confirmMessage: 'Are you sure you want to delete this contact? This cannot be undone.',
            },
        ];

        return (
            <Fragment>
                <Row>
                    <Col>
                        <h1 className="mb-5">
                            Edit contact
                        </h1>
                    </Col>
                </Row>
                <FormWithActions onAction={this.handleAction} actions={actions} disableSubmitReason={disableSubmitReason}>
                    <FormGroupRowText
                        label="First Name"
                        value={this.state.firstName}
                        onChange={value => this.handleChange(value, 'firstName')}
                    />

                    <FormGroupRowText
                        label="Last Name"
                        value={this.state.lastName}
                        onChange={value => this.handleChange(value, 'lastName')}
                    />

                    <FormGroupRowText
                        label="Email"
                        type="email"
                        value={this.state.email}
                        onChange={value => this.handleChange(value, 'email')}
                    />

                    <ButtonGroup size="sm">
                        <Button
                            outline
                            active={this.state.language === 'nl'}
                            color="success"
                            onClick={() => this.handleChange('nl', 'language')}
                            children="nl"
                        />
                        <Button
                            outline
                            active={this.state.language === 'fr'}
                            color="success"
                            onClick={() => this.handleChange('fr', 'language')}
                            children="fr"
                        />
                        <Button
                            outline
                            active={this.state.language === 'en'}
                            color="success"
                            onClick={() => this.handleChange('en', 'language')}
                            children="en"
                        />
                    </ButtonGroup>

                    <FormGroupRowCheckbox
                        label="Get Billing Report"
                        checked={this.state.getBillingReport}
                        onChange={checked => this.handleChange(checked, 'getBillingReport')}
                    />

                    <FormGroupRowSelect
                        addEmptyOption
                        label="Contact Point Type"
                        value={this.state.contactPointType}
                        onChange={value => this.handleChange(value, 'contactPointType')}
                        options={[
                            {value: 'MAIN_SPOC', label: 'MAIN_SPOC'},
                            {value: 'TECH_SPOC', label: 'TECH_SPOC'},
                        ]}
                    />

                    <FormGroupRowSelect
                        addEmptyOption
                        label="Sector Type"
                        value={this.state.sectorType}
                        onChange={value => this.handleChange(value, 'sectorType')}
                        options={sectorTypes}
                    />
                </FormWithActions>
            </Fragment>
        );
    }
}
BillingContactEditForm.propTypes = {
    billingContact: PropTypes.shape({
        id: PropTypes.number.isRequired,
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        email: PropTypes.string.isRequired,
        contactPointType: PropTypes.string.isRequired,
        sectorType: PropTypes.string.isRequired,
    }).isRequired,

    onSubmit: PropTypes.func.isRequired,
};

export default withRefresh(BillingContactEditForm);